import get from 'lodash/get';
import { Get } from 'type-fest';

import bosLabels from '../resources/bosLabels';
import labels from '../resources/labels';

const getLabel = <
  Path extends string,
  Label extends Get<typeof labels | typeof bosLabels, Path>,
  Result extends Label extends (...args: any[]) => any
    ? ReturnType<Label>
    : Label,
>(
  path: Path = '' as Path,
  ...data: Label extends (...args: infer P) => any ? P : []
): Result => {
  const label = get(labels, path, path) as Label;
  const bosLabel = get(bosLabels, path, path) as Label;
  const brand = (window as any).appConfig.BRAND_NAME;

  if (brand === 'bos' && typeof bosLabel === 'function') {
    return bosLabel(...data);
  }
  if (typeof label === 'function') {
    return label(...data);
  }

  if (brand === 'bos') {
    return bosLabel as unknown as Result;
  }
  return label as unknown as Result;
};

export default getLabel;
